$(document).on('click', '.process-time-closed-jobs-report .btn-closed-jobs-recruiters', (e) => {
  e.preventDefault();

  $('.process-time-closed-jobs-report .btn-closed-jobs-recruiters').addClass('is-selected');
  $('.process-time-closed-jobs-report .btn-closed-jobs-company-teams').removeClass('is-selected');

  $('.process-time-closed-jobs-report .closed-jobs-tab-recruiters').removeClass('is-hidden');
  $('.process-time-closed-jobs-report .closed-jobs-tab-company-teams').addClass('is-hidden');
});

$(document).on('click', '.process-time-closed-jobs-report .btn-closed-jobs-company-teams', (e) => {
  e.preventDefault();

  $('.process-time-closed-jobs-report .btn-closed-jobs-recruiters').removeClass('is-selected');
  $('.process-time-closed-jobs-report .btn-closed-jobs-company-teams').addClass('is-selected');

  $('.process-time-closed-jobs-report .closed-jobs-tab-recruiters').addClass('is-hidden');
  $('.process-time-closed-jobs-report .closed-jobs-tab-company-teams').removeClass('is-hidden');
});
